import {
  LEADS_ACTIVITY_STATUS,
  LeadsActivityStatus,
} from 'models/EnterprisesAnalytics';

export const MARGINS = { top: 8, right: 8, bottom: 8, left: 8 };

export const INNER_RADIUS = 0.72;

type LeadActivitySegment = {
  status: LeadsActivityStatus;
  color: string;
  infoKey?: string;
};

// The order here drives both the donut and the legend, so the segments keep
// their colour no matter in which order the aggregation comes back.
export const LEAD_ACTIVITY_SEGMENTS: Array<LeadActivitySegment> = [
  {
    status: LEADS_ACTIVITY_STATUS.ACTIVE_ON_DEALS,
    color: '#4318ff',
    infoKey: 'activeOnYourDealsInfo',
  },
  {
    status: LEADS_ACTIVITY_STATUS.ACTIVE_ON_RESOLVE,
    color: '#aaaaff',
    infoKey: 'activeOnResolveInfo',
  },
  {
    status: LEADS_ACTIVITY_STATUS.INACTIVE,
    color: '#dedede',
  },
];
